/**
 * Обёртка над браузерным хранилищем, которая никогда не бросает исключений.
 * Хранилище бывает недоступно: в некоторых WebView window.localStorage === null, при отключённых cookies
 * само обращение к нему бросает SecurityError, при переполнении бросает setItem(). В этих случаях данные
 * хранятся в памяти до перезагрузки страницы.
 */
class SafeStorage {
    constructor(storage) {
        this.storage = storage;
        this.memory = new Map();
    }
    get length() {
        return this.call(storage => storage.length, () => this.memory.size);
    }
    key(index) {
        return this.call(storage => storage.key(index), () => [...this.memory.keys()][index] ?? null);
    }
    getItem(key) {
        return this.call(storage => storage.getItem(key), () => this.memory.get(key) ?? null);
    }
    setItem(key, value) {
        this.call(storage => storage.setItem(key, value), () => void this.memory.set(key, String(value)));
    }
    removeItem(key) {
        this.call(storage => storage.removeItem(key), () => void this.memory.delete(key));
    }
    clear() {
        this.call(storage => storage.clear(), () => this.memory.clear());
    }
    call(action, fallback) {
        if (this.storage) {
            try {
                return action(this.storage);
            }
            catch {
                // хранилище недоступно или переполнено — работаем с памятью
            }
        }
        return fallback();
    }
}
const instances = {};
function getNativeStorage(type) {
    try {
        return window[type] ?? null;
    }
    catch {
        return null;
    }
}
function getStorage(type) {
    return instances[type] ?? (instances[type] = new SafeStorage(getNativeStorage(type)));
}
export function getLocalStorage() {
    return getStorage('localStorage');
}
export function getSessionStorage() {
    return getStorage('sessionStorage');
}
